// extracted by mini-css-extract-plugin
export var active = "industry-module--active--39d0e";
export var arrow = "industry-module--arrow--0edd6";
export var bg0 = "industry-module--bg-0--3b138";
export var bg1 = "industry-module--bg-1--89a7c";
export var bg2 = "industry-module--bg-2--3ce23";
export var bg3 = "industry-module--bg-3--20741";
export var bg4 = "industry-module--bg-4--221c9";
export var bg5 = "industry-module--bg-5--e9c3b";
export var bg6 = "industry-module--bg-6--7aa66";
export var bg7 = "industry-module--bg-7--39a1d";
export var bg8 = "industry-module--bg-8--9ddba";
export var card = "industry-module--card--be6ed";
export var cardHeader = "industry-module--card-header--22b9a";
export var cardImage = "industry-module--card-image--5c2cb";
export var cardSuper = "industry-module--card-super--edc23";
export var cards = "industry-module--cards--a0fe8";
export var ctaArrow = "industry-module--cta-arrow--0d747";
export var ctaGrid = "industry-module--cta-grid--5cc15";
export var ctaListItem = "industry-module--cta-list-item--0a806";
export var ctaListItemCopy = "industry-module--cta-list-item-copy--f7916";
export var dropDownContainer = "industry-module--drop-down-container--66daa";
export var evergreen = "industry-module--evergreen--d0b36";
export var footer = "industry-module--footer--86c61";
export var header = "industry-module--header--9c21d";
export var headerContainer = "industry-module--header-container--bd775";
export var industryItem = "industry-module--industry-item--705e8";
export var listContainer = "industry-module--list-container--02f90";
export var loadMore = "industry-module--load-more--a21e6";
export var noPad = "industry-module--no-pad--6dcc6";
export var reducePad = "industry-module--reduce-pad--4e309";